import { useContext } from 'react'
import { CryptoContext, type CryptoContextValue } from './CryptoContext'

export function useCrypto(): CryptoContextValue {
  const context = useContext(CryptoContext)
  if (!context) {
    throw new Error('useCrypto must be used within CryptoProvider')
  }
  return context
}
